export default __webpack_public_path__ + "static/media/orc.9d826a0c.svg";